module.exports = __webpack_public_path__ + "img/logo.d4c3021f.png";